import { COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX, COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
export var COMMUNICATION_CHART_HEIGHT_PX = 650;
export var COMMUNICATION_CHART_NODE_SIZE_MIN = 14;
export var COMMUNICATION_CHART_NODE_SIZE_MAX = 30;
export var COMMUNICATION_CHART_OTHER_NODE_SIZE = 24;
/** Synthetic hub nodes (meet / space chat) are slightly larger than leaf nodes. */
export var COMMUNICATION_CHART_HUB_NODE_SIZE_MULTIPLIER = 1.15;
/** Org-wide (ALL) dashboard view: team and External nodes are larger. */
export var COMMUNICATION_CHART_ORG_SCOPE_NODE_SIZE_MULTIPLIER = 1.5;
/** Team-filter chart: each teammate uses the org-team size bucket for this member count. */
export var COMMUNICATION_CHART_TEAM_SCOPE_PERSON_ORG_TEAM_MEMBER_COUNT = 8;
/** Initials font size on canvas nodes: max(min, round(radius × ratio)). */
export var COMMUNICATION_CHART_NODE_INITIALS_FONT_SIZE_MIN_PX = 10;
export var COMMUNICATION_CHART_NODE_INITIALS_FONT_SIZE_RATIO = 0.78;
export var resolveCommunicationChartNodeInitialsFontSizePx = function (nodeDiameterPx) {
    return Math.max(COMMUNICATION_CHART_NODE_INITIALS_FONT_SIZE_MIN_PX, Math.round((nodeDiameterPx / 2) * COMMUNICATION_CHART_NODE_INITIALS_FONT_SIZE_RATIO));
};
export var COMMUNICATION_CHART_SIDE_COLUMN_TOP_RATIO = 0.14;
export var COMMUNICATION_CHART_SIDE_COLUMN_USABLE_HEIGHT_RATIO = 0.72;
/** Right column x for cross-team person nodes. */
export var COMMUNICATION_CHART_CROSS_TEAM_COLUMN_X_RATIO = 0.82;
/** Left column x for employee-scope teammate peers. */
export var COMMUNICATION_CHART_EMPLOYEE_TEAMMATE_COLUMN_X_RATIO = 0.18;
/** Employee focus user is larger than peer nodes. */
export var COMMUNICATION_CHART_EMPLOYEE_FOCUS_NODE_SIZE_MULTIPLIER = 1.85;
/** Section titles on the employee-scope chart canvas. */
export var COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_FONT = '600 11px Inter, ui-sans-serif, system-ui, -apple-system, sans-serif';
export var COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_MARGIN_PX = 10;
export var COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_LINE_HEIGHT_PX = 11;
/** Space below the lowest peer node before the Teammates / Cross-team section title (clears hover names). */
export var COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_CLEARANCE_BELOW_NODE_PX = 28;
/** Bottom anchor for external / aggregate synthetic nodes (fraction of chart height). */
export var COMMUNICATION_CHART_BOTTOM_ANCHOR_Y_RATIO = 0.9;
/** Team-scope: external aggregate x when split with cross-team aggregate at bottom. */
export var COMMUNICATION_CHART_TEAM_SCOPE_EXTERNAL_AGGREGATE_X_RATIO = 0.62;
export var COMMUNICATION_CHART_TEAM_SCOPE_CROSS_TEAM_AGGREGATE_X_RATIO = 0.38;
/** Collapsed "Other" DM node on the left. */
export var COMMUNICATION_CHART_OTHER_NODE_X_RATIO = 0.14;
export var COMMUNICATION_CHART_OTHER_NODE_Y_RATIO = 0.5;
/** Skip radial hub push when parent team node is essentially at chart center. */
export var COMMUNICATION_CHART_HUB_SATELLITE_CENTER_EPSILON_PX = 0.5;
/** Max nodes on one radial ring before placing overflow on an outer ring. */
export var COMMUNICATION_CHART_RING_MAX_NODES_PER_RING = 14;
export var COMMUNICATION_CHART_RING_BASE_RADIUS_RATIO = 0.26;
export var COMMUNICATION_CHART_RING_SPACING_RATIO = 0.1;
/** Hub satellite initials on the communication chart canvas. */
export var COMMUNICATION_CHART_HUB_SATELLITE_FONT_SIZE_PX = 11;
/** Node circle design tokens used on the main chart canvas. */
export var COMMUNICATION_CHART_NODE_STYLE = {
    /** Default inner fills from the Node design card (unselected state). */
    teamFill: '#0F9D6B',
    crossTeamFill: '#3578C8',
    externalFill: '#F63939',
    borderColor: '#FFFFFF',
    borderWidth: 2,
    ringWidth: 5,
    textColor: '#FFFFFF',
    invertedFill: '#FFFFFF',
    teamRing: 'rgba(91, 196, 155, 0.28)',
    crossTeamRing: 'rgba(111, 159, 214, 0.28)',
    externalRing: 'rgba(246, 57, 57, 0.18)',
    teamDropShadow: {
        color: 'rgba(15, 23, 42, 0.22)',
        blur: 10,
        offsetY: 4
    },
    selectedDropShadow: {
        color: 'rgba(15, 23, 42, 0.18)',
        blur: 10,
        offsetY: 4
    },
    externalGlowDropShadow: {
        color: 'rgba(246, 57, 57, 0.34)',
        blur: 24,
        offsetY: 12
    }
};
export var COMMUNICATION_CHART_COLORS = {
    node: COMMUNICATION_CHART_NODE_STYLE.teamFill,
    nodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    orgTeamNodeBorder: '#CBD5E1',
    nodeSelected: COMMUNICATION_CHART_NODE_STYLE.teamFill,
    nodeText: COMMUNICATION_CHART_NODE_STYLE.textColor,
    nodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.teamRing,
    nodeDimmed: '#E2E8F0',
    externalNode: COMMUNICATION_CHART_NODE_STYLE.externalFill,
    externalNodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    externalNodeSelected: COMMUNICATION_CHART_NODE_STYLE.externalFill,
    externalNodeText: COMMUNICATION_CHART_NODE_STYLE.textColor,
    externalNodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.externalRing,
    internalMeetNode: COMMUNICATION_CHART_NODE_STYLE.teamFill,
    internalMeetNodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    internalMeetNodeSelected: COMMUNICATION_CHART_NODE_STYLE.teamFill,
    internalMeetNodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.teamRing,
    crossTeamSpaceChatNode: COMMUNICATION_CHART_NODE_STYLE.crossTeamFill,
    crossTeamSpaceChatNodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    crossTeamSpaceChatNodeSelected: COMMUNICATION_CHART_NODE_STYLE.crossTeamFill,
    crossTeamSpaceChatNodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.crossTeamRing,
    externalSpaceChatNode: COMMUNICATION_CHART_NODE_STYLE.externalFill,
    externalSpaceChatNodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    externalSpaceChatNodeSelected: COMMUNICATION_CHART_NODE_STYLE.externalFill,
    externalSpaceChatNodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.externalRing,
    crossTeamNode: COMMUNICATION_CHART_NODE_STYLE.crossTeamFill,
    crossTeamNodeBorder: COMMUNICATION_CHART_NODE_STYLE.borderColor,
    crossTeamNodeSelected: COMMUNICATION_CHART_NODE_STYLE.crossTeamFill,
    crossTeamNodeText: COMMUNICATION_CHART_NODE_STYLE.textColor,
    crossTeamNodeSelectedRing: COMMUNICATION_CHART_NODE_STYLE.crossTeamRing,
    otherNode: '#CBD5E1',
    otherNodeBorder: '#94A3B8',
    link: 'rgba(100, 116, 139, 0.38)',
    /** Unified line trend colors (all channels). */
    linkTrendUp: '#6BB89A',
    linkTrendDown: '#DE8383',
    linkTrendUnchanged: '#3B82F6',
    linkDimmed: 'rgba(148, 163, 184, 0.16)',
    linkTrendDimmed: 'rgba(59, 130, 246, 0.25)',
    /** @deprecated Channel-specific line colors removed; kept for legacy references. */
    chatLink: '#6BB89A',
    emailLink: '#9D6AD9',
    meetLink: '#3B82F6',
    /** @deprecated Use linkTrendUnchanged for legend unchanged; linkTrendUp for active lines. */
    meetLinkDimmed: 'rgba(59, 130, 246, 0.25)',
    legendLine: '#6BB89A',
    legendMeetLine: '#6BB89A',
    legendChatLine: '#6BB89A',
    legendEmailLine: '#6BB89A',
    label: '#64748B'
};
/** Cytoscape + canvas overlay opacity tokens (dimmed / default edge states). */
export var COMMUNICATION_CHART_OPACITY = {
    edge: 0.92,
    edgeDimmed: 0.2,
    edgeDimmedCanvas: 0.25,
    edgeMeetDimmed: 0.3,
    nodeDimmed: 0.42,
    nodeDimmedCanvas: 0.45
};
/** Per-org-team hues for org ALL view and hub satellites (cycle by team node id). */
export var COMMUNICATION_CHART_ORG_TEAM_NODE_PALETTES = [
    { main: '#3578C8', ring: 'rgba(111, 159, 214, 0.28)' },
    { main: '#7C4DCC', ring: 'rgba(146, 110, 214, 0.28)' },
    { main: '#F4B740', ring: 'rgba(244, 183, 64, 0.28)' },
    { main: '#2E9D8F', ring: 'rgba(94, 187, 173, 0.28)' },
    { main: '#5B6EE1', ring: 'rgba(130, 145, 234, 0.28)' },
    { main: '#A855C8', ring: 'rgba(190, 115, 220, 0.28)' }
];
export var COMMUNICATION_CHART_CROSS_TEAM_SATELLITE_GREY_PALETTE = {
    main: '#94A3B8',
    ring: 'rgba(148, 163, 184, 0.28)'
};
export var COMMUNICATION_CHART_DIMMED_PERSON_NODE_PALETTE = {
    main: COMMUNICATION_CHART_COLORS.otherNode,
    ring: 'rgba(148, 163, 184, 0.35)'
};
export var COMMUNICATION_CHART_CHAT_EDGE_CONTROL_POINT_DISTANCE = 12;
export var COMMUNICATION_CHART_MEET_EDGE_CONTROL_POINT_DISTANCE = -12;
export var COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE = 12;
export var COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE = 12;
/** Opposite bend from mix/external hub lines so spokes do not cross. */
export var COMMUNICATION_CHART_INTERNAL_MEET_HUB_EDGE_CONTROL_POINT_DISTANCE = -12;
/** In-team 1:1 chat spoke to Team-only hub (curved to the right). */
export var COMMUNICATION_CHART_INTERNAL_DM_HUB_EDGE_CONTROL_POINT_DISTANCE = 12;
export var COMMUNICATION_CHART_NODE_RADIUS = 8;
export var COMMUNICATION_CHART_EXTERNAL_NODE_RADIUS = 14;
export var COMMUNICATION_CHART_EXTERNAL_NODE_INITIALS = 'EX';
export var COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_INITIALS = 'CT';
export var COMMUNICATION_CHART_INTERNAL_MEET_NODE_RADIUS = 11;
export var COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_RADIUS = 11;
export var COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_RADIUS = 11;
/** Angular offset from the team spoke for yellow cross-team space nodes (radians). */
export var COMMUNICATION_CHART_CROSS_TEAM_SPACE_NODE_ANGLE_OFFSET_RAD = Math.PI / 18;
/** Angular offset from the team spoke for green Team-only nodes (mirrors cross-team). */
export var COMMUNICATION_CHART_INTERNAL_MEET_NODE_ANGLE_OFFSET_RAD = -COMMUNICATION_CHART_CROSS_TEAM_SPACE_NODE_ANGLE_OFFSET_RAD;
/** Angular offset for grey external space nodes (opposite side from yellow). */
export var COMMUNICATION_CHART_EXTERNAL_SPACE_NODE_ANGLE_OFFSET_RAD = -COMMUNICATION_CHART_CROSS_TEAM_SPACE_NODE_ANGLE_OFFSET_RAD;
/** Line width bounds used for arrow length bands (matches chart stroke range). */
export var COMMUNICATION_CHART_MIN_LINE_WIDTH_PX = COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX;
export var COMMUNICATION_CHART_MAX_LINE_WIDTH_PX = COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX;
/** Length (tip to rear) = wingspan × this factor. */
export var COMMUNICATION_CHART_ARROW_LENGTH_TO_WINGSPAN_RATIO = 1.2;
/** Arrow wingspan (px) per exact line width and tier. */
export var COMMUNICATION_CHART_ARROW_WINGSPAN_BY_LINE_WIDTH_PX = {
    1: { small: 7, medium: 9, large: 11 },
    2: { small: 8, medium: 10, large: 12 },
    3: { small: 9, medium: 11, large: 13 },
    4: { small: 10, medium: 12, large: 14 },
    5: { small: 11, medium: 13, large: 15 },
    6: { small: 12, medium: 14, large: 16 }
};
var clampCommunicationChartLineWidthPx = function (lineWidthPx) {
    return Math.min(COMMUNICATION_CHART_MAX_LINE_WIDTH_PX, Math.max(COMMUNICATION_CHART_MIN_LINE_WIDTH_PX, Math.round(lineWidthPx)));
};
export var resolveCommunicationChartArrowWingspanPx = function (arrowSize, lineWidthPx) {
    if (arrowSize === 'none' || lineWidthPx <= 0) {
        return 0;
    }
    var lineWidth = clampCommunicationChartLineWidthPx(lineWidthPx);
    return COMMUNICATION_CHART_ARROW_WINGSPAN_BY_LINE_WIDTH_PX[lineWidth][arrowSize];
};
/** Arrow length (depth) in px from wingspan × 1.2. */
export var resolveCommunicationChartArrowWidthPx = function (arrowSize, lineWidthPx) {
    var wingspanPx = resolveCommunicationChartArrowWingspanPx(arrowSize, lineWidthPx);
    if (wingspanPx <= 0) {
        return 0;
    }
    return wingspanPx * COMMUNICATION_CHART_ARROW_LENGTH_TO_WINGSPAN_RATIO;
};
/** Cytoscape node inset: line stops one arrow depth before the node border. */
export var resolveCommunicationChartArrowGapPx = function (arrowSize, lineWidthPx) {
    if (arrowSize === 'none' || lineWidthPx <= 0) {
        return 0;
    }
    return resolveCommunicationChartArrowWidthPx(arrowSize, lineWidthPx);
};
